module.exports = __webpack_public_path__ + "img/4colorMeter.d11c7f56.svg";